<template>
    <setting-layout :title="$t('pages.user.setting.creator.mystery_box.title')" class="mystery-box">
        <v-container>
            <v-form ref="form" class="auth-form">
                <v-row>
                    <v-col cols="6">
                        <div class="total-earning">
                            <div>
                                <span>{{ currency }}{{ earned }}</span>
                            </div>
                            <strong>{{ $t('pages.user.setting.creator.mystery_box.total_earning') }}</strong>
                        </div>
                    </v-col>
                    <v-col cols="6">
                        <div class="total-earning">
                            <div>
                                <span >
                                    {{ active ? 'Active' : 'Inactive' }}
                                </span>
                            </div>
                            <strong> {{ $t('pages.user.setting.creator.mystery_box.status') }} </strong >
                        </div>
                    </v-col>
                </v-row>
                <div class="mt-4">
                    <h2 class="mb-3"> {{ $t('pages.user.setting.creator.mystery_box.heading') }} </h2>
                </div>
                <!-- PRICE -->
                <v-row class="align-center box-price pb-1">
                    <v-col cols="6">
                        <text-field
                            v-model="price"
                            :placeholder="$t('pages.user.setting.creator.mystery_box.price')"
                            :error-messages="errors.price"
                            :prepend="currency"
                            @keyup.enter="save"
                            outlined
                        />
                    </v-col>
                    <!-- TOTAL BOXES -->
                    <v-col cols="6">
                        <text-field
                            v-model="total_boxes"
                            :placeholder="$t('pages.user.setting.creator.mystery_box.total_available')"
                            :error-messages="errors.total_boxes"
                            outlined
                            type="number"
                        />
                    </v-col>
                </v-row>

                <!-- DESCRIPTION -->
                <v-row class="mt-3">
                    <v-col cols="12">
                        <v-textarea
                            v-model="description"
                            :placeholder="$t('pages.user.setting.creator.mystery_box.description')"
                            :counter="200"
                            :error-messages="errors.description"
                            outlined
                            style="border-radius: 8px"
                            class="decription_text"
                        />
                    </v-col>
                </v-row>

                <!-- REWARDS -->
                <v-row class="mt-6 mb-6">
                    <v-col cols="12">
                        <div class="d-flex justify-space-between align-center mb-0">
                            <h4> {{ $t('pages.user.setting.creator.mystery_box.prize_table') }} </h4>
                            <v-btn class="px-0 add-price-btn" small @click="addReward" :disabled="rewards.length >= 10">
                               <add-reward-icon />
                                <span>{{ $t('pages.user.setting.creator.mystery_box.add_prize') }} </span> </v-btn>
                        </div>
                        <span class="toggle-description d-inline-block mb-4"> {{ $t('pages.user.setting.creator.mystery_box.add_message') }} </span>

                        <div v-for="(reward, index) in rewards" :key="index" class="reward-item d-flex align-center justify-space-between">
                            <div class="d-flex align-center justify-start gap-4">
                                <!-- Number -->
                                <div class="reward-number">{{ String(index + 1).padStart(2, "0") }}</div>
                                <!-- Title Input -->
                                <div class="reward-title ms-2">
                                    <text-field
                                        v-model="reward.title"
                                        placeholder="Reward name (leave blank = empty reward)"
                                    />
                                </div>
                            </div>


                            <!-- Quantity Selector -->
                            <div class="reward-qty d-flex align-center">
                                <button type="button" class="qty-btn" @click="decreaseQty(index)">−</button>
                                <span class="qty-value">{{ reward.quantity }}</span>
                                <button type="button" class="qty-btn" @click="increaseQty(index)">+</button>
                            </div>

                            <!-- Remove Button -->
                            <v-btn icon @click="removeReward(index)">
                               <app-icon icon="delete" size="28" />
                            </v-btn>
                        </div>
                    </v-col>
                </v-row>

                 <!-- ALLOW MULTIPLE -->
                <v-row>
                    <v-col cols="12">
                        <div class="d-flex justify-space-between align-center allow-multiple-items"> 
                            <label for="mutiple-toggle" class="mb-0">
                                <strong> {{ $t('pages.user.setting.creator.mystery_box.allow_multiple') }} </strong>
                            </label>
                            <v-switch
                                id="multiple-toggle"
                                v-model="allow_multiple"
                                hide-details
                                class="ma-0 pa-0"
                            />
                        </div>
                        <span class="toggle-description"> {{ $t('pages.user.setting.creator.mystery_box.allow_multiple_desc') }} </span>
                    </v-col>
                </v-row>

                <!-- ACTIVATE / DEACTIVATE + Earned Display -->
                <!-- <v-row v-if="boxLoaded">
                    <v-col cols="12" class="mt-4">
                        <div class="d-flex justify-space-between align-center"> 
                            <label for="mutiple-toggle" class="mb-0">
                                <strong> {{ $t('pages.user.setting.creator.mystery_box.box_status') }} </strong>                                                          
                            </label>
                            <v-switch
                                id="multiple-toggle"
                                v-model="status"
                                hide-details
                                class="ma-0 pa-0" @click="boxStatus" />
                        </div>
                        <span class="toggle-description" style="font-size: 14px;"> {{ $t('pages.user.setting.creator.mystery_box.box_status_desc') }}
                            <strong> {{ active ? 'Active' : 'Inactive' }} </strong> 
                        </span>
                    </v-col>
                </v-row>  -->

                <v-row v-if="boxLoaded">
                    <v-col cols="12" class="mt-4">
                        <div class="d-flex justify-space-between align-center"> 
                            <label>
                                <strong> {{ $t('pages.user.setting.creator.mystery_box.remaining_boxes') }} : </strong>
                                <span> {{ remaining }} </span>
                            </label>
                        </div> 
                    </v-col>
                </v-row>
                <!-- SAVE BUTTON -->
                <v-row class="mt-6" align="center" justify="center">
                    <gradient-button v-if="!active" block @click="save" :loading="$store.state.buttonsLoading.MysteryBoxBtn"> {{ $t('pages.user.setting.creator.mystery_box.save') }} </gradient-button>
                    <gradient-button v-else block @click="turnOffMysteryBox"> {{ $t('pages.user.setting.creator.mystery_box.turn_of_box') }} </gradient-button>
                </v-row>

            </v-form>
        </v-container>
    </setting-layout>
</template>


<script>
import SettingLayout from "@/layouts/app/profile/SettingLayout";
import GradientButton from "@/components/app/button/GradientButton.vue";
import TextField from "@/components/app/form/TextField";
import { CURRENCY_SYMBOL } from "@/configs/constants";
import { mapActions, mapMutations, mapState } from "vuex";
import AddRewardIcon from "@/assets/images/icons/add_rewards.svg?inline";

export default {
    name: "MysteryBox",
    data: () => ({
        price: '',
        total_boxes: '',
        description: '',
        allow_multiple: true,
        status: true,
        rewards: [{ title: '', quantity: 1 }],
        errors: {},
        currency: CURRENCY_SYMBOL,
        active: false,
        earned: 0,
        boxLoaded: false,
        box_id: '',
        remaining: 0,
        mysteryBoxData: {}
    }),
    components: { SettingLayout, GradientButton, TextField, AddRewardIcon },
    computed: {
        ...mapState({
            currentUser: (state) => state.user.user.data,
        }),
    },
    async created() {
        try {
            let res = await this.getMysteryBox();
            if (res) {

                res = res.data;
                this.mysteryBoxData = res.data;
                this.price = res.price;
                this.total_boxes = res.total_boxes;
                this.description = res.description;
                this.allow_multiple = res.allow_multiple;
                this.rewards = res.rewards;
                this.active = res.status;
                this.earned = res.earned;
                this.status = res.status;
                this.boxLoaded = true;
                this.box_id = res.id;
                this.remaining = res.total_boxes - res.sold_boxes;
            }
        } catch (e) {
            this.boxLoaded = true;
        }
    },
    methods: {
        ...mapMutations(["showSnackBar"]),
        ...mapActions([
            "saveMysteryBox",
            "activateMysteryBox",
            "deactivateMysteryBox",
            "getMysteryBox",
        ]),

        addReward() {
            this.rewards.push({ title: '', quantity: 1 });
        },
        removeReward(index) {
            this.rewards.splice(index, 1);
        },

        boxStatus() {
            if(this.status) {
                this.active = true;
            } else {
                this.active = false;
            }
        },

        async save() {
            this.errors = {};
            this.status = true;
            const totalQty = this.rewards.reduce((sum, r) => sum + Number(r.quantity), 0);
            if (totalQty !== Number(this.total_boxes)) {
                this.showSnackBar("Reward total must match total boxes");
                return;
            }

            try {
                await this.saveMysteryBox({ 
                    model: {
                        price: this.price,
                        total_boxes: this.total_boxes,
                        description: this.description,
                        allow_multiple: this.allow_multiple ? 1 : 0,
                        rewards: this.rewards,
                        status: this.status ? 1 : 0,
                        creator_id: this.currentUser.id,
                        box_id: this.box_id,
                    }
                }).then((res) => {
                    this.active = true;
                });
                this.showSnackBar("Mystery Box Saved");
            } catch (err) {
                this.errors = err.response?.data?.errors || {};
            }
        },

        increaseQty(index) {
            this.rewards[index].quantity++;
        },

        decreaseQty(index) {
            if (this.rewards[index].quantity > 0) {
                this.rewards[index].quantity--;
            }
        },

        async turnOffMysteryBox() {
            try {
                this.active = false;
                await axios.post(`/api/mystery-box/status/${this.box_id}`, { status: this.active })
                    .then((response) => {
                        this.showSnackBar("Mystery Box Status Updated!");
                    })
            } catch(err) {
                this.errors = err
            }
        },
    }
}
</script>

<style scoped>

.toggle-description {
    font-size: 13px;
    color: #a3a3a3;
}

.mystery-box .container { border-top: 1px solid rgba(255, 255, 255, 0.15); margin-top: 20px; padding: 26px 24px; }
.mystery-box .container .row { margin: 0 -4.5px; }
.mystery-box .container .row .col.col-6, .mystery-box .container .row .col.col-12 { padding: 0 4.5px; }
.mystery-box .container .total-earning { border: 1px solid rgba(85, 85, 85, 1); border-radius: 14px; padding: 25px 16px; }
.mystery-box .container .total-earning span { display: inline-block; background-image: linear-gradient(354.8deg, #FF7805 4.66%, #FFA702 83.25%); color: transparent; background-clip: text; font-weight: 800; font-size: 28px; line-height: 32px; letter-spacing: -1px; text-transform: capitalize; margin-bottom: 8px; }

.mystery-box .container .total-earning strong { color: rgba(255, 255, 255, 1); font-weight: 500; font-size: 16px; line-height: 22.75px; letter-spacing: -0.5px; }
.mystery-box .container .box-price .v-input { font-weight: 500; font-size: 16px; line-height: 22.75px; letter-spacing: 0px; }
.mystery-box .container .box-price .v-input .v-input__slot, .mystery-box .container .v-input__control .v-input__slot .v-text-field__slot{ min-height: 52px; background: rgba(31, 31, 31, 1) !important; border-color: transparent !important; box-shadow: none; border-radius: 12px; padding: 9.5px 16px; line-height: 1; }

.mystery-box .container .v-textarea .v-input__slot { height: 133px; background: rgba(31, 31, 31, 1) !important; border-color: transparent !important; margin-bottom: 0; }

.mystery-box .container .v-textarea .v-text-field__details { position: absolute; bottom: 10px; right: -10px; }
.mystery-box .container .v-textarea .v-text-field__details .v-counter { color: rgba(255, 255, 255, 0.4); font-weight: 500; font-size: 10px; line-height: 15px; letter-spacing: 0px; }

.mystery-box .container h4 { color: rgba(255, 255, 255, 1); font-weight: 700; font-size: 20px; line-height: 18px; letter-spacing: 0px; text-transform: capitalize; }
.mystery-box .container .add-price-btn span { display: flex; align-items: center; gap: 6px; background-image: linear-gradient(354.8deg, #FF7805 4.66%, #FFA702 83.25%); color: transparent; background-clip: text; font-weight: 700; font-size: 14px; line-height: 28px; letter-spacing: 0px; text-align: center; margin-left: 10px; }

.mystery-box .reward-item {  background-color: rgba(31, 31, 31, 1); border-top: 1px solid rgba(48, 48, 48, 1); border-radius: 12px; padding: 9px 14px; margin-bottom: 8px; }

.mystery-box .reward-item .reward-number { background-image: linear-gradient(354.8deg, #FF7805 4.66%, #FFA702 83.25%); color: transparent; -webkit-background-clip: text; background-clip: text; font-weight: 700; font-size: 16px; line-height: 24.55px; letter-spacing: 0px; }
.mystery-box .reward-item .reward-title input { font-weight: 700; font-size: 16px; line-height: 1; letter-spacing: 0px; background-color: transparent; box-shadow: none; }
.mystery-box .reward-item .reward-qty { display: flex; gap: 10px; align-items: center; justify-content: center; border-top: 1px solid rgba(39, 39, 42, 0.81); background-color: rgba(0, 0, 0, 1); border-radius: 8px; padding: 14px 10px; }
.mystery-box .reward-item .reward-qty .qty-btn { width: 20px; }

.mystery-box  .allow-multiple-items label strong { color: rgba(255, 255, 255, 1); font-weight: 700; font-size: 16px; line-height: 1; letter-spacing: 0px; }

</style> 